// extracted by mini-css-extract-plugin
export default {"title":"edit-location_title__Zz4Zl","field":"edit-location_field__MQsiQ","line":"edit-location_line__KCJ2P","content":"edit-location_content__BVKVV"};